// Armonia — mișcare și feedback. Calm, o direcție, o singură dată.
//
// 1. Feedback la trimiterea formularelor: butonul cu `data-text-trimitere` spune „Se trimite…"
//    și nu mai primește un al doilea tap sau Enter. Rulează și cu mișcare redusă — nu e mișcare.
// 2. Animațiile decorative de la încărcare (zoom-ul lent din hero, showroom-ul, pinii din scene)
//    pornesc abia după primul cadru DESENAT (Paint Timing) și după `load`, prin clasa `anim-ok`
//    pe <html>. Pornite mai devreme, Chrome headless (Lighthouse, PageSpeed) amâna randarea cu
//    ~1 s: homepage 74 → 95–97 fără ele (măsurat 22.09.2026). Pe telefoanele reale nu
//    întârziau nimic — doar scorul.
// 3. Reveal la scroll (fade + ridicare, stagger scurt, cortină pe imagini): DOAR pe elementele de
//    sub primul ecran — nimic din ce se vede la încărcare nu pornește ascuns, deci LCP-ul nu
//    așteaptă după JavaScript. Clasele se scot după animație, ca hover-ul cardurilor să rămână al
//    lor. Stilurile: armonia-chrome.css.
(function () {
  function reseteaza(b) {
    if (b.getAttribute('aria-busy') !== 'true') return;
    b.removeAttribute('aria-busy');
    b.removeAttribute('aria-disabled');
    b.style.pointerEvents = '';
    b.textContent = b.getAttribute('data-text-initial') || b.textContent;
  }
  // Faza de CAPTURĂ: protecția anti-bot a Shopify de pe formularele de contact anulează
  // `submit`-ul în faza de bule și retrimite formularul programatic după verificare
  // (măsurat 22.09.2026) — un ascultător obișnuit n-ar vedea niciodată trimiterea.
  // Butonul NU se dezactivează: retrimiterea programatică trebuie să rămână posibilă.
  document.addEventListener('submit', function (e) {
    var buton = e.target.querySelector('[data-text-trimitere]');
    if (!buton || buton.getAttribute('aria-busy') === 'true') return;
    buton.setAttribute('data-text-initial', buton.textContent);
    buton.textContent = buton.getAttribute('data-text-trimitere');
    buton.setAttribute('aria-busy', 'true');
    buton.setAttribute('aria-disabled', 'true');
    buton.style.pointerEvents = 'none';
    // plasă: dacă pagina n-a plecat în 8 s (verificare anulată, rețea picată), butonul revine
    setTimeout(function () { reseteaza(buton); }, 8000);
  }, true);
  // pointer-events oprește doar mouse-ul și tap-ul: cât timp formularul pleacă, Enter într-un
  // câmp (nu în textarea — acolo e rând nou) și Enter/Space pe butonul ocupat nu mai trimit încă o dată
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var formular = e.target.form || (e.target.closest && e.target.closest('form'));
    var buton = formular && formular.querySelector('[data-text-trimitere][aria-busy="true"]');
    if (!buton) return;
    if (e.target === buton || (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA')) e.preventDefault();
  }, true);
  // Înapoi din istoric (bfcache): pagina revine cu butonul încă în „Se trimite…".
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    [].forEach.call(document.querySelectorAll('[data-text-trimitere][aria-busy]'), reseteaza);
  });

  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Pornire: după `load` ȘI după ce browserul a raportat primul cadru desenat
  // (`first-contentful-paint`), plus 1 s. Pe live, cu bannerul de cookie al Shopify, `load`
  // vine înaintea primului cadru prezentat în Chrome headless — pornite la `load`, animațiile
  // îl amânau din nou (homepage 72; cu scriptul blocat 96 — măsurat 22.09.2026). Zoom-ul
  // durează 18 s: o secundă în plus la pornire nu se vede.
  var pornite = false;
  var desenat = false;
  var incarcat = document.readyState === 'complete';
  function pornesteAnimatiile() {
    if (pornite || !desenat || !incarcat) return;
    pornite = true;
    setTimeout(function () { document.documentElement.classList.add('anim-ok'); }, 1000);
  }
  try {
    new PerformanceObserver(function (lista, obs) {
      if (!lista.getEntriesByName('first-contentful-paint').length) return;
      desenat = true;
      obs.disconnect();
      pornesteAnimatiile();
    }).observe({ type: 'paint', buffered: true });
  } catch (e) {
    desenat = true; // fără Paint Timing: pornim doar după load + 1 s
  }
  if (!incarcat) {
    window.addEventListener('load', function () { incarcat = true; pornesteAnimatiile(); });
  }
  pornesteAnimatiile();

  // Fără IntersectionObserver nu marcăm nimic: `.rv` ar ascunde conținutul definitiv.
  if (!('IntersectionObserver' in window)) return;

  var RISE = 'h2,.pagehead,.prod,.rcard,.quote,.convcard,.info,.thumbs,.fnews,.shin>div';
  var CURTAIN = '.shin>img';

  // Gata animația → elementul revine la stilurile lui. Plasa de siguranță (1,6 s) acoperă cazul
  // în care `animationend` nu vine (tab ascuns, animație anulată): nimic nu rămâne invizibil.
  function curata(el) {
    el.classList.remove('rv', 'rv-img', 'in');
    el.style.animationDelay = '';
  }
  function dezvaluie(el, i) {
    el.style.animationDelay = Math.min(i * 60, 240) + 'ms';
    // `animationend` urcă din copii — contează doar animația elementului însuși
    el.addEventListener('animationend', function gata(ev) {
      if (ev.target !== el) return;
      el.removeEventListener('animationend', gata);
      curata(el);
    });
    setTimeout(function () { curata(el); }, 1600);
    el.classList.add('in');
  }

  // Marcarea se face la DOMContentLoaded — după TOATE scripturile defer: armonia-produs.js strânge
  // descrierea la câteva rânduri, iar un titlu măsurat înainte ar fi urcat apoi în primul ecran
  // deja ascuns.
  function pregateste() {
    var ecran = window.innerHeight;
    var sub = function (el) { return el.getBoundingClientRect().top > ecran; };

    var rises = [].slice.call(document.querySelectorAll(RISE)).filter(sub);
    rises.forEach(function (el) { el.classList.add('rv'); });
    var io = new IntersectionObserver(function (intrari) {
      intrari.filter(function (e) { return e.isIntersecting; }).forEach(function (e, i) {
        dezvaluie(e.target, i);
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -60px 0px', threshold: 0.06 });
    rises.forEach(function (el) { io.observe(el); });

    // Cortinele se observă direct pe imagine, cu prag 0: rândul de 1px lăsat vizibil de clip-path
    // (armonia-chrome.css) îi dă o intersecție nenulă. Printr-un părinte — cum era înainte —
    // pe telefon cortina rula cu ~480px înainte ca imaginea să intre în ecran.
    var cortine = [].slice.call(document.querySelectorAll(CURTAIN)).filter(sub);
    cortine.forEach(function (el) { el.classList.add('rv-img'); });
    var ioImg = new IntersectionObserver(function (intrari) {
      intrari.filter(function (e) { return e.isIntersecting; }).forEach(function (e) {
        dezvaluie(e.target, 0);
        ioImg.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -40px 0px', threshold: 0 });
    cortine.forEach(function (el) { ioImg.observe(el); });
  }
  if (document.readyState === 'complete') pregateste();
  else document.addEventListener('DOMContentLoaded', pregateste);
})();
